import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, ElementRef } from "@angular/core";
import { ExportStep10Component } from "./export-step10/export-step10.component";
import { ExportStep30Component } from "./export-step30/export-step30.component";
import { ExportStep40Component } from "./export-step40/export-step40.component";
import { WizardComponent } from "../../shared/components/wizard/wizard.component";
import { SyncDataService } from "../services/sync-data.service";
import { IFacadeExportObject } from "app/core/typings/IFacadeExportObject";

@Component({
  selector: "biz-sync-data-export",
  templateUrl: "./sync-data-export.component.html",
  styleUrls: ["./sync-data-export.component.scss"]
})

export class SyncDataExportComponent implements OnInit {
  @ViewChild("locationSelector", { static: false }) locationSelector: ElementRef;
  @ViewChild(TemplateRef, { static: false }) template: TemplateRef<any>;
  @Output() onFinish = new EventEmitter();
  public exportOnlyUsers = false;

  public steps: Array<any>;
  public syncData: IFacadeExportObject;
  public initialStep = 0;
  public messageBody: string;

  constructor(private _syncDataService: SyncDataService) {
    this.syncData = {
      EnabledMail: false,
      FilePath: "",
      FileToImport: null,
      Reports: null,
      OverrideTargetResources: null,
      EntityTables: null,
      UserTables: null,
      StringConnection: "",
      ProviderType: "",
      AreNewUsers: true,
      ModifiedDescriptor: "",
      OriginalDescriptor: "",
      UsersAvailable: true,
      UsersSelected: true
    };
  }

  ngOnInit() {
    this.steps = [ExportStep10Component, ExportStep30Component, ExportStep40Component];
  }

  public onNext() {
    this.initialStep += 1;
  }

  public onPrevious() {
    this.initialStep -= 1;
  }

  public onExport() {
    this.exportOnlyUsers = true;
  }

  public exportLoading(event) {
    if (event)
      this.initialStep = 2;
    this.exportOnlyUsers = false;
  }

  public closeModal() {
    this.onFinish.emit();
  }

  public setData(data) {
    this.syncData = _.extend(this.syncData, data);
  }

  public isSelectedSomeUser() {
    return this.syncData.UserTables && this.syncData.UserTables.some(user => user.Selected);
  }

  public isSelectedSomeEntity() {
    return this.syncData.EntityTables && this.syncData.EntityTables.some(entity => entity.Selected);
  }

  public isSelectedSomeEntityKey() {
    return this.syncData.EntityTables && this.syncData.EntityTables.filter(entity =>
      entity.EntityKeysSource.some(key => key.Selected || (!key.Selected && !key.IsBusinessKey))).length === this.syncData.EntityTables.length;
  }

}
